<template>
  <v-dialog v-model="dialog" :persistent="true" max-width="35%">
    <template>
      <v-card>
        <v-card-title class="text-left pb-6">{{ `${$tc('title.atencao', 1)}!` }}</v-card-title>
        <v-card-text>
          <v-row>
            <span class="pl-3" v-html="`${$t('message.deseja_inativar_rep_conj_com_fluxo_em_aberto_listagem', {
                gruposFornecedores: gruposFornecedores,
            })}`"></span>
          </v-row>
        </v-card-text>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn id="nao" color="primary darken-1" text @click.native="disagree">
          {{$t('label.nao')}}
        </v-btn>
        <v-btn id="sim" color="primary darken-1" text @click.native="agree">
          {{$t('label.sim')}}
        </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalRepConjuntoInativadoFluxoAberto',
  data() {
    return {
      dialog: false,
      gruposFornecedores: '',
    };
  },
  methods: {
    open(dados) {
      this.gruposFornecedores = dados;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    disagree() {
      this.$emit('disagree');
      this.close();
    },
    agree() {
      this.$emit('agree');
      this.close();
    },
  },
};
</script>
<style lang="scss">
.justify {
  text-align: justify;
}
</style>
